<template>
  <div>
    <v-row class="mb-3">
      <v-col cols="8" md="6">
        <v-text-field
            v-model="retailer_search_query"
            :placeholder="$lang.RETAILER_SEARCH"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            rounded
            @keyup="getRetailerList"
        ></v-text-field>
      </v-col>
      <v-col class="text-right" cols="4" md="6">
        <span
            class="cursor-pointer"
            @click="$router.push({ name: 'add-retailer' })"
        >
          <span class="secodry-text-4 mr-3">{{
              $lang.ADD_A_RETAILER.toUpperCase()
            }}</span>
          <v-btn color="primary" depressed fab small>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </span>
      </v-col>
      <v-col class="mt-2" cols="12" md="6">
        <div
            v-for="(item, i) in retailer_type_option"
            :key="i"
            :class="
            filter_retailer.retailer_type == item
              ? 'elevation-1 border-rounded'
              : 'elevation-0'
          "
            class="filter-btn status-text-filter px-4 py-1 mx-2 cursor-pointer"
            @click="applyFilter(item)"
        >
          {{ item }}
        </div>
        <div
            v-if="$store.state.user_type==$keys.SUPER_ADMIN"
            :class="
            assign_line == 'Yes'
              ? 'elevation-1 border-rounded'
              : 'elevation-0'
          "
            class="filter-btn status-text-filter px-4 py-1 mx-2 cursor-pointer"
            @click="newRetailerFilter">
          {{ $lang.NEW_RETAILER }}
        </div>
      </v-col>

    </v-row>
    <!--  -->
    <div>
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="retailer_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
          @click:row="gotoRetailerDetails"
      >
        <template v-slot:item.verification>
          <v-icon color="#27AE60"> mdi-check</v-icon>
          <v-icon color="error"> mdi-window-close</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="gotoRetailerDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg"/>
          </v-btn>
        </template>
        <!--  empty state  -->
        <template v-slot:no-data>
          <empty-list
              :message="$lang.EMPTY_RETAILER"
              :type="$keys.EMPTY_TYPE_2"
          />
        </template>
      </v-data-table>
      <v-pagination
          v-model="page_number"
          :length="total_page_count"
          :total-visible="7"
          class="custome-pagination"
          @input="getRetailerList"
      ></v-pagination>
    </div>
  </div>
</template>

<script type="text/javascript">
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      total_page_count: 1,
      page_number: 1,
      table_loading: false,
      retailer_search_query: "",
      assign_line: "",
      retailer_type_option: ["All", "Registered", "Unregistered"],
      retailer_list: [],
      headers: [
        {text: "Name", align: "start", value: "retailer_firm_name"},
        {text: "Mobile", value: "retailer_mobile_number"},
        {text: "Full Address", value: "retailer_full_address"},
        {text: "Location", value: "retailer_location"},
        // { text: 'Verification', value: 'verification' },
        {text: "", value: "action"},
      ],
    };
  },
  computed: mapGetters({
    filter_retailer: "retailers/getRetailerFilter",
  }),
  created() {
    this.$store.dispatch("setPageLoader", true);
    this.getRetailerList(false);
  },
  methods: {
    applyFilter(item) {
      this.$store.dispatch("retailers/setRetailerFilter", {
        retailer_type: item,
      });
      this.assign_line = "No"

      this.getRetailerList();
    },
    newRetailerFilter() {
      this.assign_line = "Yes"
      this.$store.dispatch("retailers/setRetailerFilter", {
        retailer_type: null,
      });

      this.getRetailerList();
    },
    /* fetching shipment list */
    getRetailerList(is_cancel = true) {
      const self = this;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.retailer_search_query,
        retailer_type: this.filter_retailer.retailer_type,
        "assign_line": this.assign_line,
      };

      self.table_loading = true;

      const successHandler = (response) => {
        if (response.data.success) {
          this.retailer_list = response.data.retailer_list;
          this.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
          self,
          self.$urls.RETAILER_MANAGE_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
      );
    },
    /* redirect to shipment details*/
    gotoRetailerDetails(item) {
      this.$router.push({
        name: "retailer-details",
        params: {retailer_id: this.encript(item.retailer_id)},
      });
    },
  },
};
</script>